import React, { lazy, Suspense } from "react";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
/**
 *
 * @param {Function} func eg. ()=>import('./Dashboard')
 */
export default function LazyLoad(func: () => Promise<{ default: React.ComponentType }>) {
  const LazyLoadComponent = lazy(func);
  return class LoadableDashboard extends React.Component {
    render() {
      return (
        <Suspense fallback={<AccessAlarmIcon />}>
          <LazyLoadComponent {...this.props} />
        </Suspense>
      );
    }
  };
}
